/* global BMap */
import _ from 'lodash';

/// 点操作

// 判断两个点数组是否包含相同的点
export const areSamePoints = (points1, points2) => {
    if (points1.length !== points2.length) {
        // 如果两种元素个数不同，肯定不同
        return false;
    }

    const set1 = new Set(points1.map(p => p.lng + ':' + p.lat));
    const set2 = new Set(points2.map(p => p.lng + ':' + p.lat));

    // 并集
    const union = new Set([...set1, ...set2]);
    // 并集 size 相同说明，两 set1 和 set2 相同
    return union.size === set1.size;
};

// 返回 pointsA 与 pointsB 交集, pointsA 的剩余部分，以及 pointsB 的剩余部分
// 即返回 [pointsA ∩ pointsB, pointsA - pointsB, pointsB - pointsA]
export const pointsIntersectDiffDiff = (pointsA, pointsB) => {
    const [joined, restA, restB] = [[], [...pointsA], []];
    for (const p of pointsB) {
        const index = _.findIndex(restA, pA => pA.lng === p.lng && pA.lat === p.lat);
        if (index !== -1) {
            joined.push(p);
            restA.splice(index, 1);
        } else {
            restB.push(p);
        }
    }
    return [joined, restA, restB];
};

// pointsA - pointsB: 从 pointsA 中去除 pointsA 的元素
export const pointsSubstract = (pointsA, pointsB) => {
    const result = [...pointsA];
    for (const p of pointsB) {
        const index = _.findIndex(result, pResult => pResult.lng === p.lng && pResult.lat === p.lat);
        if (index !== -1) {
            result.splice(index, 1);
        }
    }
    return result;
};

// 合并点，去重, "并集"
export const pointsUnion = (pointsA, pointsB) => {
    const result = [...pointsA];
    for (const p of pointsB) {
        if (!_.find(result, pResult => pResult.lng === p.lng && pResult.lat === p.lat)) {
            result.push(p);
        }
    }
    return result;
};

// 点去重
export const distinctPoints = (points) => {
    const exists = new Map();
    return points.filter(point => {
        const key = '' + point.lat + ':' + point.lng;
        if (!exists.has(key)) {
            exists.set(key, true);
            return true;
        }
        return false;
    });
};

// 在同一经纬度的点
export const pointsAt = (lat, lng, points) => {
    return points.filter(point => point.lat === lat && point.lng === lng);
};

// 在同一经纬度的Task
export const tasksAt = (lat, lng, points) => {
    return points.filter(point => {
        const [taskLng, taskLat] = taskLngLat(point);
        return taskLng === lng && taskLat === lat;
    });
};

// 在同长方形中的点
export const pointsInRect = (latMin, lngMin, latMax, lngMax, points) => {
    return points.filter(point => {
        const [lat, lng] = [point.lat, point.lng];
        return latMin <= lat && lat <= latMax && lngMin <= lng && lng <= lngMax;
    });
};

// 在同长方形中的Task
export const tasksInRect = (latMin, lngMin, latMax, lngMax, points) => {
    // console.log(latMin, lngMin, latMax, lngMax, points);
    return points.filter(point => {
        const [lng, lat] = taskLngLat(point);
        return latMin <= lat && lat <= latMax && lngMin <= lng && lng <= lngMax;
    });
};

// task 转 point
export const taskToPoint = (task) => {
    const [lng, lat] = taskLngLat(task);
    return new BMap.Point(lng, lat); // 像素点转经纬度
};
export const taskLngLat = (task) => {
    // 除了inOutType为IN的取start_Ing和start_Lat，其他的都是按目前的取end_Ing和end_Lat
    if (task.inOutType === 'IN') {
        return [task.startLng, task.startLat];
    } else {
        return [task.endLng, task.endLat];
    }
};

export const taskHasNoLngLat = (task) => {
    const [lng, lat] = taskLngLat(task);
    return typeof lng !== 'number' || typeof lat !== 'number';
};

// 去掉重复(基于经纬度)的任务，并合并相同经纬度点的totalPackageQuantity和totalVolume
// TODO: 标记同一经纬度多个点的情况
export const distinctTasksByLngLat = (points) => {
    const pointMap = new Map();

    points.forEach(point => {
        const [lng, lat] = taskLngLat(point); // taskLngLat 取经纬度
        const key = '' + lat + ':' + lng;

        if (pointMap.has(key)) {
            // 如果已存在相同坐标点，累加totalPackageQuantity和totalVolume
            const existingPoint = pointMap.get(key);
            existingPoint.totalPackageQuantity = (existingPoint.totalPackageQuantity || 0) + (point.totalPackageQuantity || 0);
            existingPoint.totalVolume = (existingPoint.totalVolume || 0) + (point.totalVolume || 0);
        } else {
            // 如果是新的坐标点，直接添加
            pointMap.set(key, { ...point });
        }
    });
    return Array.from(pointMap.values());
};

// 去掉重复的任务
export const distinctTasks = (tasks) => {
    const exists = new Map();
    return tasks.filter(t => {
        if (!exists.has(t.taskNo)) {
            exists.set(t.taskNo, true);
            return true;
        }
        return false;
    });
};

// 随机颜色
export const generateRandomHexColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
};

// 值是否相同
export const hasDifferentVal = (arr,key) => {
    const uniqueVal = new Set(arr.map(obj => obj[key]));
    return uniqueVal.size > 1; // 如果有多个不同的值，返回 true
};
